
export function oxgExtractPriceFromString(string) {
  // Define the regular expressions for the various cases
  const priceNormal = /\d+\.\d+\s/; // e.g. 122.45 €
  const priceComma = /\d+,\d+\.\d+\s/; // e.g. 1,456.75 $
  const priceGerman = /\d+\,\d+\s/; // e.g. 122,45 €
  const priceGermanDecimal = /\d+\.\d+\,\d+\s/; // e.g. 1.256,75 €

  let price = string.match(priceNormal);

  if (!price) {
    price = string.match(priceComma); 
    price = price ? price[0].replace(/,/g, '') : null; // 1,456.75 => 1456.75
  }
  if (!price) { 
    price = string.match(priceGerman); 
    price = price ? price[0].replace(/,/g, '.') : null; // 122,45 => 122.45
  }
  if (!price) { 
    price = string.match(priceGermanDecimal); 
    if (price) {
      price = price[0].replace(/\./g, '').replace(/,/g, '.'); // 1.456,75 => 1456.75
    }
  }

  // If we found a match, trim spaces and return the cleaned price
  return price ? price[0].trim() : null;
}

export function oxgSlugifyStringNoEndTrim(input) {
  if (!input || typeof input != 'string') return ''
  let slug = input
    .toLowerCase()                    // Convert to lowercase
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/ß/g, 'ss')              // Convert ß to ss
    .replace(/[^a-z0-9- ]/g, '')      // Remove non-alphanumeric characters except dashes and spaces
    .replace(/_/g, '-')               // Convert underscores to dashes
    .replace(/\s+/g, '-')             // Replace spaces with dashes
    .replace(/-+/g, '-')             // Replace multiple dashes with a single dash
    .replace(/^-+/g, '');            // Remove leading dashes

  if (/^[0-9]/.test(slug)) {
    slug = 'x-' + slug; // Prepend 'x-' if it starts with a number
  }
  return slug
}

export function oxgSlugifyString(input) {
  if (!input || typeof input != 'string') return ''
  let slug = input
    .toLowerCase()                    // Convert to lowercase
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/ß/g, 'ss')              // Convert ß to ss
    .replace(/[^a-z0-9- ]/g, '')      // Remove non-alphanumeric characters except dashes and spaces
    .replace(/_/g, '-')               // Convert underscores to dashes
    .replace(/\s+/g, '-')             // Replace spaces with dashes
    .replace(/-+/g, '-')             // Replace multiple dashes with a single dash
    .replace(/^-+|-+$/g, '');         // Remove leading and trailing dashes

  if (/^[0-9]/.test(slug)) {
    slug = 'x-' + slug; // Prepend 'x-' if it starts with a number
  }
  return slug
}

export function oxgReplaceUrlParametersInString(input) {
  // Regular expression to match "?param=" or "&param=" where param is a sequence of a-z, A-Z, and optional 0-9 characters
  // Replaces ?, & and = with hyphen (-), if the characters are in the form of a url parameter (i.e. ?param1=)
  input = input.replace(/([&?])([a-zA-Z]+[0-9]*[a-zA-Z]*)=/g, '-$2-');
  return input
}

export function oxgIsStringPageAmountPrintable(input) {
  const sanitizedInput = input.replace(/\s+/g, ''); // Remove spaces
  // Check if the input is 1, 2, or divisible by 4
  if (sanitizedInput === "1" || sanitizedInput === "2" || parseInt(sanitizedInput, 10) % 4 === 0) {
      return true;
  }
  return false;
}

export function oxgIsStringNumber(input) {
  const sanitizedInput = input.replace(/\s+/g, ''); // removes spaces
  const pattern = /^(1|2|\d*[048])$/ 
  if (pattern.test(sanitizedInput)) {
    return true;
  }
  return false;
}

export function oxgIsValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

export function oxgAutoCorrectPhoneNumber(input, event) {
  // Check if Shift, Ctrl, or specific key combinations are pressed
  const isModifierKeyPressed = event.shiftKey || event.ctrlKey || event.altKey;
  const isSpecialKey = (event.key === 'a' && event.ctrlKey) || 
                       (event.key === 'c' && event.ctrlKey) || 
                       (event.key === 'x' && event.ctrlKey);

  // If a modifier key or special key combination is pressed, do not format
  if (isModifierKeyPressed || isSpecialKey) {
      return input; // Return the original input without formatting
  }

  // If input is null or empty, return the input as is
  if (!input) {
      return input; // Do not add +49 when the input is empty
  }

  // Remove any extra spaces between numbers but keep single spaces
  input = input.replace(/\s+/g, ' '); // Replace multiple spaces with a single space

  // If the first character is not a "+", assume it's a local German number
  if (input[0] !== '+') {
      // If the phone number starts with a "0", replace it with "(0)"
      if (input[0] === '0') {
          input = input.replace(/^0/, '(0)');
      }

      // Prepend "+49" if it's not already an international number
      if (!input.startsWith('+49')) {
          input = '+49 ' + input;
      }
  }

  return input; // Return the formatted phone number
}

/*
export function oxgFindRangeOfNumber(number, ranges) {
  // Get the hidden field value and parse it
  const hiddenFieldValue = document.querySelector('.page-ranges').value;
  const ranges = JSON.parse(hiddenFieldValue.replace(/'/g, '"')); // Replace single quotes to make it a valid JSON string

  for (let range of ranges) {
      if (range.includes('-')) {
          // Handle ranges like '2-6'
          let [min, max] = range.split('-').map(Number);
          if (value >= min && value <= max) {
              return range;
          }
      } else if (range.startsWith('>')) {
          // Handle ranges like '>16'
          let min = Number(range.slice(1));
          if (value > min) {
              return range;
          }
      } else if (range.startsWith('<')) {
          // Handle ranges like '<10' if needed
          let max = Number(range.slice(1));
          if (value < max) {
              return range;
          }
      }
  }
  return null; // Return null if no range is found
} 
  */